import { defineMessages } from 'react-intl'

export const jobPageMessages = defineMessages({
  noJobFound: {
    id: 'jobInfo.noJobFound',
    description: 'No job info found message on JobInfo page',
    defaultMessage: 'No job info found',
  },
})
